export const CheckGrayIcon = ({ className }: { className?: string }) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M5.83063 15.7117C6.16937 15.7117 6.42162 15.5604 6.60901 15.2865L15.5315 1.2973C15.6756 1.07388 15.7334 0.900899 15.7334 0.72793C15.7334 0.288288 15.445 0 15.0054 0C14.7027 0 14.5225 0.108108 14.3423 0.4036L5.79459 13.9099L1.42702 8.36033C1.23243 8.09368 1.04505 7.9784 0.749545 7.9784C0.30991 7.9784 0 8.28107 0 8.71354C0 8.90093 0.072072 9.09547 0.230631 9.29008L5.02342 15.2721C5.26126 15.5747 5.49909 15.7117 5.83063 15.7117Z'
      fill='#8A8A8A'
    />
  </svg>
);
